(function () {
  function init() {
    var root = document.getElementById('lp-root');
    if (!root) return;

    var lang = root.getAttribute('data-lang') || (document.documentElement.lang || 'es-UY');

    var FREE_PRODUCT_VARIANT_ID = 10120764424468; // Aceitero 300ml (regalo)
    var LITERS_PER_UNIT = { '3l': 3, '5l': 5, 'other': 1 };
    var LITERS_PER_MONTH = 1; // consumo promedio de una pareja cocinando en casa

    // ===== ESCALERA =====
    // Estos porcentajes DEBEN coincidir con los descuentos automáticos del Admin.
    // 'paid' en 3l/1 es correcto mientras el umbral de envío gratis sea $2.500.
    var RULES = {
      '3l': {
        sin: {
          1: { discount: 0,  shipping: 'paid' },
          2: { discount: 10, shipping: 'free' },
          4: { discount: 15, shipping: 'free' }
        },
        con: {
          1: { discount: 7,  shipping: 'free' },
          2: { discount: 15, shipping: 'free' },
          4: { discount: 20, shipping: 'free' }
        }
      },
      '5l': {
        sin: {
          1: { discount: 0,  shipping: 'free' },
          2: { discount: 10, shipping: 'free' },
          3: { discount: 15, shipping: 'free' }
        },
        con: {
          1: { discount: 7,  shipping: 'free' },
          2: { discount: 15, shipping: 'free' },
          3: { discount: 20, shipping: 'free' }
        }
      }
    };

    var state = { basePrice: 0, comparePrice: 0, qty: 1, variantType: '3l', mode: 'onetime', subDiscount: 0.10 };

    // Formato de plata igual al filtro money de Shopify: $3.582 (no "3.582 UYU")
    function moneyFromCents(cents) {
      var n = Math.round((parseInt(cents || '0', 10) || 0) / 100);
      try {
        return '$' + new Intl.NumberFormat(lang, { maximumFractionDigits: 0 }).format(n);
      } catch (e) {
        return '$' + n;
      }
    }

    function detectVariantType(title) {
      var t = (title || '').toLowerCase();
      if (t.indexOf('3') !== -1) return '3l';
      if (t.indexOf('5') !== -1) return '5l';
      return 'other';
    }

    function monthsFor(liters) { return Math.round(liters / LITERS_PER_MONTH); }

    function durationLabel(liters) {
      var months = monthsFor(liters);
      if (months === 12) return 'Un año de aceite';
      if (months > 12 && months % 12 === 0) return (months / 12) + ' años de aceite';
      return months + ' meses de aceite';
    }

    function durationShort(liters) {
      var months = monthsFor(liters);
      if (months === 12) return '1 año';
      return months + ' meses';
    }

    function qtyLabel(qty, liters) {
      return qty + (qty === 1 ? ' bidón · ' : ' bidones · ') + liters + (liters === 1 ? ' litro' : ' litros');
    }

    function basePriceFor(type) {
      var vt = root.querySelector('#lpVariantTiles .lp-tile[data-variant-type="' + type + '"]');
      if (vt) return parseInt(vt.getAttribute('data-price') || '0', 10);
      return state.basePrice;
    }

    function getActiveRule() {
      var t = state.variantType === '5l' ? '5l' : '3l';
      var m = state.mode === 'sub' ? 'con' : 'sin';
      return (RULES[t] && RULES[t][m] && RULES[t][m][state.qty]) || { discount: 0, shipping: 'paid' };
    }

    function calculatePrices() {
      var rule = getActiveRule();
      var subtotal = state.basePrice * state.qty;
      var compareTotal = state.comparePrice * state.qty;
      var afterQty = subtotal * (1 - rule.discount / 100);
      var finalPrice = state.mode === 'sub' ? afterQty * (1 - state.subDiscount) : afterQty;
      return {
        final: Math.round(finalPrice),
        compare: compareTotal > finalPrice ? compareTotal : 0,
        subtotal: subtotal,
        rule: rule
      };
    }

    function fillTiles() {
      var m = state.mode === 'sub' ? 'con' : 'sin';

      ['3l', '5l'].forEach(function (type) {
        var wrap = root.querySelector('.lp-qty-options[data-type="' + type + '"]');
        if (!wrap) return;

        var unitLiters = LITERS_PER_UNIT[type] || 1;
        var base = basePriceFor(type);

        wrap.querySelectorAll('.lp-qty-tile').forEach(function (tile) {
          var q = parseInt(tile.getAttribute('data-qty') || '1', 10);
          var r = (RULES[type][m] && RULES[type][m][q]) || { discount: 0, shipping: 'paid' };

          var subtotal = base * q;
          var total = Math.round(subtotal * (1 - r.discount / 100));
          if (m === 'con') total = Math.round(total * (1 - state.subDiscount));

          var liters = unitLiters * q;
          var perLiter = liters > 0 ? Math.round(total / liters) : 0;
          var saved = subtotal - total;

          function set(sel, value) {
            var el = tile.querySelector(sel);
            if (el) el.textContent = value;
          }

          set('.lp-qty-dur', durationLabel(liters));
          set('.lp-qty-units', qtyLabel(q, liters));
          set('.lp-qty-total', moneyFromCents(total));
          set('.lp-qty-perl', moneyFromCents(perLiter) + ' por litro');

          var wasEl = tile.querySelector('.lp-qty-was');
          if (wasEl) {
            wasEl.textContent = saved > 0 ? moneyFromCents(subtotal) : '';
            wasEl.style.display = saved > 0 ? '' : 'none';
          }

          var saveEl = tile.querySelector('.lp-qty-save');
          if (saveEl) {
            saveEl.textContent = saved > 0 ? ('Ahorrás ' + moneyFromCents(saved)) : '';
            saveEl.style.display = saved > 0 ? '' : 'none';
          }

          var badge = tile.querySelector('.lp-qty-badge');
          if (badge) {
            var parts = [];
            if (r.discount > 0) parts.push('-' + r.discount + '%');
            parts.push(r.shipping === 'free' ? 'Envío gratis' : 'Envío $189');
            badge.textContent = parts.join(' · ');
            badge.style.display = '';
          }
        });
      });
    }

    function buildCheckoutUrl() { return '/checkout'; }

    function addFreeProduct() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: FREE_PRODUCT_VARIANT_ID, quantity: 1, properties: { _free_gift: 'true' } }] })
      });
    }

    function saveSubscriberData() {
      try {
        var rule = getActiveRule();
        localStorage.setItem('lp_pending_subscription', JSON.stringify({
          variantType: state.variantType, qty: state.qty,
          discount: rule.discount, shipping: rule.shipping,
          date: new Date().toISOString().split('T')[0]
        }));
      } catch (e) {}
    }

    var mainImg = document.getElementById('lpMainImg');
    var thumbs = root.querySelectorAll('.lp-thumb');
    var vTiles = root.querySelectorAll('#lpVariantTiles .lp-tile');
    var variantInput = document.getElementById('lpVariantId');
    var qtyContainer = document.getElementById('lpQtyTiles');
    var qtyInput = document.getElementById('lpQtyInput');
    var shippingInput = document.getElementById('lpShippingMethod');
    var discountInput = document.getElementById('lpDiscountApplied');
    var priceNow = document.getElementById('lpPriceNow');
    var priceCompare = document.getElementById('lpPriceCompare');
    var oneTime = document.getElementById('lpOneTimePrice');
    var subPrice = document.getElementById('lpSubPrice');
    var btn = document.getElementById('lpCtaBtn');
    var cuotasEl = document.getElementById('lpCuotas');
    var sticky = document.getElementById('lpSticky');
    var stickyBtn = document.getElementById('lpStickyBtn');
    var stickyPrice = sticky ? sticky.querySelector('.lp-sticky-price') : null;
    var stickySub = sticky ? sticky.querySelector('.lp-sticky-sub') : null;
    var modes = root.querySelectorAll('#lpPurchase .lp-radio');
    var modeInput = document.getElementById('lpPurchaseMode');
    var tabBtns = root.querySelectorAll('.lp-tab-btn');
    var panels = {
      details: document.getElementById('lpTab-details'),
      harvest: document.getElementById('lpTab-harvest'),
      uses: document.getElementById('lpTab-uses'),
      refills: document.getElementById('lpTab-refills')
    };

    // ============================================================
    // Widgets flotantes (WhatsApp, Quiero+ / Clientif, etc.)
    // La barra de compra ocupa el borde inferior, asi que los
    // corremos hacia arriba mientras la barra esta a la vista.
    // No dependemos de las clases de cada app: buscamos elementos
    // fixed, chicos y pegados abajo, hijos directos del body.
    // ============================================================
    var shifted = [];

    function shiftWidgets(offset) {
      shifted.forEach(function (el) { el.style.transform = ''; });
      shifted = [];
      if (!offset) return;

      var vh = window.innerHeight || document.documentElement.clientHeight;

      Array.prototype.forEach.call(document.body.children, function (el) {
        if (!el || el.nodeType !== 1) return;
        if (el === sticky) return;
        if (el.contains(root) || root.contains(el)) return;

        var cs;
        try { cs = window.getComputedStyle(el); } catch (e) { return; }
        if (!cs || cs.position !== 'fixed') return;
        if (cs.display === 'none' || cs.visibility === 'hidden') return;

        var r = el.getBoundingClientRect();
        if (!r.height || !r.width) return;
        if (r.height > 260) return;            // no tocar overlays grandes ni modales
        if (r.bottom < vh - 200) return;       // solo lo que vive pegado abajo

        el.style.transition = 'transform .18s ease';
        el.style.transform = 'translateY(-' + offset + 'px)';
        shifted.push(el);
      });
    }

    function stickyIsVisible() {
      if (!sticky || sticky.hidden) return false;
      try { return window.getComputedStyle(sticky).display !== 'none'; }
      catch (e) { return false; }
    }

    function syncWidgets() {
      shiftWidgets(stickyIsVisible() ? (sticky.offsetHeight + 12) : 0);
    }

    function updateAllPrices() {
      var prices = calculatePrices();
      var rule = prices.rule;
      var liters = (LITERS_PER_UNIT[state.variantType] || 1) * state.qty;
      var perLiter = liters > 0 ? Math.round(prices.final / liters) : 0;

      if (priceNow) {
        var html = moneyFromCents(prices.final);
        if (rule.discount > 0) html += '<span class="lp-discount-badge">-' + rule.discount + '%</span>';
        if (rule.shipping === 'free') html += '<span class="lp-shipping-badge">Envío gratis</span>';
        html += '<span class="lp-perliter-badge">' + moneyFromCents(perLiter) + ' / litro</span>';
        // Qué es lo que cuesta eso: cantidad, duración y precio por día.
        // Sin esta línea el total de 2 bidones parecía el precio de uno.
        var months = monthsFor(liters);
        var perDay = months > 0 ? Math.round(prices.final / (months * 30)) : 0;
        html += '<span class="lp-price-for" style="flex-basis:100%;width:100%;margin-top:4px;font-size:13px;line-height:1.3;font-weight:700;color:#243a2b;">' + qtyLabel(state.qty, liters) + ' · ' + durationShort(liters) + ' de aceite · ' + moneyFromCents(perDay) + ' por día</span>';
        priceNow.innerHTML = html;
      }

      if (priceCompare) {
        if (prices.compare > prices.final) {
          priceCompare.textContent = moneyFromCents(prices.compare);
          priceCompare.style.display = '';
        } else {
          priceCompare.style.display = 'none';
        }
      }

      if (oneTime) oneTime.textContent = moneyFromCents(Math.round(state.basePrice * state.qty * (1 - rule.discount / 100)));
      if (subPrice) subPrice.textContent = moneyFromCents(Math.round(state.basePrice * state.qty * (1 - rule.discount / 100) * (1 - state.subDiscount)));

      if (btn && !btn.disabled) {
        var btnText = state.mode === 'sub' ? 'SUSCRIBIRSE' : 'AGREGAR AL CARRITO';
        var ship = rule.shipping === 'free' ? ' + ENVÍO GRATIS' : '';
        btn.innerHTML = btnText + ' — ' + moneyFromCents(prices.final) + ship;
      }

      if (cuotasEl) {
        var n = parseInt(cuotasEl.getAttribute('data-cuotas') || '10', 10);
        var label = cuotasEl.getAttribute('data-label') || '';
        if (n > 1 && prices.final > 0) {
          cuotasEl.innerHTML = 'O en ' + n + ' pagos de <strong>' + moneyFromCents(Math.round(prices.final / n)) + '</strong> por mes ' + label;
        } else {
          cuotasEl.innerHTML = '';
        }
      }

      if (stickyPrice) stickyPrice.textContent = moneyFromCents(prices.final);
      if (stickySub) {
        var unitL = LITERS_PER_UNIT[state.variantType] || 1;
        var bits = [state.qty + ' × ' + unitL + ' L', durationShort(liters), moneyFromCents(perLiter) + '/L'];
        if (rule.shipping === 'free') bits.push('Envío gratis');
        stickySub.textContent = bits.join(' · ');
      }
      if (stickyBtn && btn) stickyBtn.disabled = btn.disabled;

      if (shippingInput) shippingInput.value = rule.shipping === 'free' ? 'Gratis' : 'Pago';
      if (discountInput) discountInput.value = rule.discount + '%';

      fillTiles();
    }

    function setActiveQty(tile) {
      root.querySelectorAll('.lp-qty-tile').forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-checked', 'false');
      });
      tile.classList.add('is-active');
      tile.setAttribute('aria-checked', 'true');
      state.qty = parseInt(tile.getAttribute('data-qty') || '1', 10);
      if (qtyInput) qtyInput.value = String(state.qty);
      updateAllPrices();
    }

    function switchQuantityOptions(type) {
      if (!qtyContainer) return;
      qtyContainer.querySelectorAll('.lp-qty-options').forEach(function (o) { o.style.display = 'none'; });
      var activeType = (type === '5l') ? '5l' : '3l';
      var active = qtyContainer.querySelector('.lp-qty-options[data-type="' + activeType + '"]');
      if (active) active.style.display = '';
      qtyContainer.setAttribute('data-current-type', activeType);
      state.variantType = activeType;

      var t = active ? (active.querySelector('.lp-qty-tile.is-active') || active.querySelector('.lp-qty-tile')) : null;
      if (t) { setActiveQty(t); }
      else { state.qty = 1; if (qtyInput) qtyInput.value = '1'; updateAllPrices(); }
    }

    function setActiveVariant(tile) {
      vTiles.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
      tile.classList.add('is-active');
      tile.setAttribute('aria-checked', 'true');

      var titleEl = tile.querySelector('.lp-tile-title');
      state.basePrice = parseInt(tile.getAttribute('data-price') || '0', 10);
      state.comparePrice = parseInt(tile.getAttribute('data-compare') || '0', 10);
      state.variantType = tile.getAttribute('data-variant-type') || detectVariantType(titleEl ? titleEl.textContent : '');

      switchQuantityOptions(state.variantType);

      var id = tile.getAttribute('data-variant-id');
      if (variantInput && id) variantInput.value = id;

      if (btn) {
        if (tile.getAttribute('data-available') !== 'true') {
          btn.disabled = true;
          btn.textContent = 'SIN STOCK';
          btn.style.opacity = '0.65';
          btn.style.cursor = 'not-allowed';
        } else {
          btn.disabled = false;
          btn.style.opacity = '';
          btn.style.cursor = '';
        }
      }
      updateAllPrices();
    }

    if (thumbs && thumbs.length && mainImg) {
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          var url = b.getAttribute('data-large');
          if (!url) return;
          mainImg.style.opacity = '0';
          window.setTimeout(function () { mainImg.src = url; mainImg.style.opacity = '1'; }, 140);
        });
      });
    }

    vTiles.forEach(function (tile) {
      tile.addEventListener('click', function () { setActiveVariant(tile); });
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActiveVariant(tile); }
      });
    });

    root.querySelectorAll('.lp-qty-tile').forEach(function (tile) {
      tile.addEventListener('click', function () { setActiveQty(tile); });
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActiveQty(tile); }
      });
    });

    modes.forEach(function (m) {
      function setMode() {
        modes.forEach(function (x) { x.classList.remove('is-active'); });
        m.classList.add('is-active');
        state.mode = m.getAttribute('data-mode');
        if (modeInput) modeInput.value = (state.mode === 'sub') ? 'Subscription' : 'One time';
        updateAllPrices();
      }
      m.addEventListener('click', setMode);
      m.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setMode(); }
      });
    });

    tabBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-tab');
        tabBtns.forEach(function (x) {
          var is = x.getAttribute('data-tab') === key;
          x.classList.toggle('is-active', is);
          x.setAttribute('aria-selected', is ? 'true' : 'false');
        });
        Object.keys(panels).forEach(function (k) { if (panels[k]) panels[k].hidden = (k !== key); });
      });
    });

    if (stickyBtn && btn) {
      stickyBtn.addEventListener('click', function () { btn.click(); });
    }

    // La barra aparece cuando el boton real NO esta en pantalla.
    var ctaBox = root.querySelector('.lp-cta');
    if (sticky && ctaBox) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { sticky.hidden = e.isIntersecting; });
          syncWidgets();
        }, { threshold: 0 }).observe(ctaBox);
      } else {
        sticky.hidden = false;
        syncWidgets();
      }

      window.addEventListener('resize', syncWidgets);
      window.addEventListener('orientationchange', function () { window.setTimeout(syncWidgets, 250); });

      // Las apps cargan sus widgets tarde: los reubicamos cuando aparecen.
      if ('MutationObserver' in window) {
        var mo = new MutationObserver(function () { syncWidgets(); });
        mo.observe(document.body, { childList: true });
      }
      [800, 2000, 4500].forEach(function (ms) { window.setTimeout(syncWidgets, ms); });
    }

    var form = document.getElementById('lpForm');
    var pop = document.getElementById('lpCartPop');

    if (pop) {
      pop.querySelectorAll('[data-close]').forEach(function (el) {
        el.addEventListener('click', function () { pop.hidden = true; });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !pop.hidden) pop.hidden = true;
      });
    }

    if (form && window.fetch && window.FormData) {
      form.addEventListener('submit', function (e) {
        if (btn && btn.disabled) return;
        e.preventDefault();
        var prevHtml = btn ? btn.innerHTML : '';
        var prevSticky = stickyBtn ? stickyBtn.textContent : '';
        if (btn) { btn.disabled = true; btn.innerHTML = 'AGREGANDO…'; }
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'AGREGANDO…'; }

        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error('add_failed'); return r.json(); })
          .then(function () {
            if (state.mode === 'sub') { saveSubscriberData(); return addFreeProduct(); }
            return Promise.resolve();
          })
          .then(function () {
            if (btn) { btn.disabled = false; btn.innerHTML = prevHtml; }
            if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = prevSticky; }
            var cb = pop ? pop.querySelector('.lp-cart-pop__btn--primary') : null;
            if (cb) cb.href = buildCheckoutUrl();
            if (pop) pop.hidden = false;
          })
          .catch(function () {
            try { form.action = buildCheckoutUrl(); form.submit(); }
            catch (err) { window.location.href = buildCheckoutUrl(); }
          });
      });
    }

    var first = root.querySelector('#lpVariantTiles .lp-tile.is-active') || root.querySelector('#lpVariantTiles .lp-tile');
    if (first) { setActiveVariant(first); } else { updateAllPrices(); }
    syncWidgets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();